import { UserRole, User } from "redux/Slice/user-slice";

export const isRoleInUse = (role: Role | string, user: User) => {
  const name = typeof role === "string" ? role : role?.role;
  return !!user?.roles?.some((ur: UserRole) => ur?.role?.role === name);
};
